import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5e4932a1"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "main"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "margin-top": "18px"
  }
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "text"
}, "您已经成功退出单点登录，谢谢使用！")], -1));
const _hoisted_3 = {
  style: {
    "margin-top": "32px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svg_icon = _resolveComponent("svg-icon");
  const _component_a_button = _resolveComponent("a-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", null, [_createVNode(_component_svg_icon, {
    iconClass: "logoutPageIcon",
    className: "logoutPageIcon"
  })]), _hoisted_2, _createElementVNode("div", _hoisted_3, [_createVNode(_component_a_button, {
    onClick: $options.againLogin
  }, {
    default: _withCtx(() => [_createTextVNode("重新登录")]),
    _: 1
  }, 8, ["onClick"])])]);
}